import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/todaysSurgery';

import SurgeryReport from './SurgeryReport';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.todays_surgery,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(SurgeryReport);
